import styled, { useTheme } from "styled-components/native";
import React from "react";
import { VDBText } from "@components/atoms";
import { Linking, Platform, TouchableOpacity, View } from "react-native";
import { LabelContainerProps } from "./types";
import { css } from "styled-components/native";

const TwoColumnLabelView = ({
  labelText,
  valueLText,
  valueRText,
  keyWidth,
  valueWidthPercent,
  direction = "row",
  keyTypographyStyle,
  valueTypographyStyle,
  ellipsize = true,
  containerJustifyContent = "flex-start",
  itemLeftTextTheme,
  isFixWidth,
  selectableRightValue = true,
  marginRight = 0,
  clickableHandle,
  onPhoneClick,
}: LabelContainerProps) => {
  const theme = useTheme();

  const ClickableValueItem = ({ text }: { text: string }) => (
    <VDBText
      type={valueTypographyStyle}
      isBold={true}
      color={theme["core-05"]}
      numberOfLines={ellipsize ? 1 : 0}
      ellipsizeMode="tail"
      style={{ paddingTop: 0, paddingBottom: 0 }}
      selectable={Platform.OS === "web"}
    >
      {text}
    </VDBText>
  );

  const ValueItem = ({ text }: { text: string }) => (
    <VDBText
      type={valueTypographyStyle}
      isBold={true}
      color={theme["core-05"]}
      numberOfLines={ellipsize ? 1 : 0}
      ellipsizeMode={ellipsize ? "tail" : "clip"}
      selectable={selectableRightValue}
    >
      {text}
    </VDBText>
  );

  const handleDialer = (dialerText?: string) => {
    if (dialerText !== "-") {
      onPhoneClick?.();
      if (Platform.OS === "ios") {
        Linking.openURL("telprompt: " + dialerText);
      } else {
        Linking.openURL("tel: " + dialerText);
      }
    }
  };

  return (
    <ContainerView
      justifyContent={containerJustifyContent}
      direction={direction}
      isFixWidth={isFixWidth}
    >
      <LeftLabelContainer keyWidth={keyWidth}>
        {labelText && (
          <VDBText
            type={keyTypographyStyle}
            color={itemLeftTextTheme ? itemLeftTextTheme : theme["core-06"]}
            selectable={Platform.OS === "web"}
          >
            {labelText}
          </VDBText>
        )}
      </LeftLabelContainer>
      <RightLabelContainer
        isFixWidth={isFixWidth}
        widthPercent={valueWidthPercent}
      >
        <LeftValueContainer>
          <View style={{ marginRight: marginRight }}>
            {clickableHandle ? (
              <TouchableOpacity
                activeOpacity={0.8}
                onPress={() => handleDialer(valueLText)}
              >
                <ClickableValueItem text={valueLText} />
              </TouchableOpacity>
            ) : (
              <ValueItem text={valueLText} />
            )}
          </View>
        </LeftValueContainer>
        {valueRText ? (
          <RightValueContainer>
            <View style={{ marginRight: marginRight }}>
              {clickableHandle ? (
                <TouchableOpacity
                  activeOpacity={0.8}
                  onPress={() => handleDialer(valueRText)}
                >
                  <ClickableValueItem text={valueRText} />
                </TouchableOpacity>
              ) : (
                <ValueItem text={valueRText} />
              )}
            </View>
          </RightValueContainer>
        ) : undefined}
      </RightLabelContainer>
    </ContainerView>
  );
};

const ContainerView = styled.View<{
  justifyContent: string;
  direction: string;
  isFixWidth?: boolean;
}>`
  flex-direction: ${({ direction }) => direction || "row"};
  justify-content: ${({ justifyContent }) => justifyContent};
  max-width: 100%;
`;
const LeftLabelContainer = styled.View<any>`
  align-items: start;
  flex-direction: row;
  align-items: center;
  ${(props) =>
    props.keyWidth &&
    css`
      width: ${props.keyWidth}px;
    `};
  margin-left: ${({ theme }) => (theme.isMobile ? "16px" : 0)};
`;
const RightLabelContainer = styled.View<{
  isFixWidth?: boolean;
  widthPercent?: number;
}>`
  flex-direction: row;
  ${({ isFixWidth }) =>
    isFixWidth &&
    css`
      flex: 1;
    `};
  ${(props) =>
    props.widthPercent &&
    css`
      width: ${props.widthPercent}%;
    `};
`;

const LeftValueContainer = styled.View`
  width: 50%;
  ${({ theme }) =>
    theme.isLargeScreen &&
    css`
      flex: 1;
    `};
`;

const RightValueContainer = styled.View`
  width: 50%;
  ${({ theme }) =>
    theme.isLargeScreen &&
    css`
      flex: 1;
    `};
`;
export default TwoColumnLabelView;
